export enum ComplexPolymerActionType {
  MODBIO_UPDATE_COMPLEX_POLYMER_VERSION_ID = 'MODBIO_UPDATE_COMPLEX_POLYMER_VERSION_ID',
  MODBIO_UPDATE_COMPLEX_POLYMER_EDITING_STATE = 'MODBIO_UPDATE_COMPLEX_POLYMER_EDITING_STATE',
}

export interface UpdateComplexPolymerVersionAction {
  type: ComplexPolymerActionType.MODBIO_UPDATE_COMPLEX_POLYMER_VERSION_ID;
  complexPolymerId: string;
  complexPolymerVersionId: string;
}

export function updateComplexPolymerVersion(
  complexPolymerId: string,
  complexPolymerVersionId: string
): ComplexPolymerAction {
  return {
    type: ComplexPolymerActionType.MODBIO_UPDATE_COMPLEX_POLYMER_VERSION_ID,
    complexPolymerId,
    complexPolymerVersionId,
  };
}

export interface UpdateComplexPolymerEditingStateAction {
  type: ComplexPolymerActionType.MODBIO_UPDATE_COMPLEX_POLYMER_EDITING_STATE;
  complexPolymerId: string;
  isEditing: boolean;
}

export function updateComplexPolymerEditingState(
  complexPolymerId: string,
  isEditing: boolean
): ComplexPolymerAction {
  return {
    type: ComplexPolymerActionType.MODBIO_UPDATE_COMPLEX_POLYMER_EDITING_STATE,
    complexPolymerId,
    isEditing,
  };
}

export type ComplexPolymerAction = UpdateComplexPolymerVersionAction | UpdateComplexPolymerEditingStateAction;
